import gql from "graphql-tag";

// noinspection GraphQLUnresolvedReference
export const salesforceRetailersQuery = gql`query {
  salesforceRetailers {
    retailerId
  }
}`;